// This validator takes an array of FormControl names and will succeed if any of the FormControls has a value

import { AbstractControl, ValidatorFn } from "@angular/forms"

export function AnyRequiredValidator(controlNames: string[]): ValidatorFn {
  return (group: AbstractControl): { [key: string]: any } | null => {
    let hasValue = false;
    for (let controlName of controlNames) {
      let control = group.get(controlName);
      if (control && control.value) {
        hasValue = true;
        break;
      }
    }

    return hasValue ? null : { "anyRequired": true };
  }
}
